import React from "react";
import './s1.scss';
import { APP_LINK } from "../../../utils";

const S1 = () => {
  return (
    <div className="gogo-s-1">
      <p className="title">¡Préstamos rápidos y sin complicaciones!</p>
      <p className="sub-title">Baja requisitos, altos montos y desembolso inmediato para tu tranquilidad financiera.</p>
      {
        APP_LINK &&
        <a className="gp" href={APP_LINK}></a>
      }
      <div className="people absolute"></div>
      <div className="phone absolute"></div>
      <div className="spark absolute"></div>
      <div className="dollar absolute"></div>
      <div className="dollar-2 absolute"></div>
    </div>
  )
}

export default S1;
